export enum ServiceTier {
	Ecommerce = 'E-Commerce',
	AssistedSales = 'Assisted Sales',
	AccountManaged = 'Account Managed',
	VIP = 'VIP',
}
